import { useState, useEffect, useCallback } from "react";
import {
  getCurrentUser,
  type CurrentUser,
} from "../../../../store/instanceManagement/instanceService";
import { logger } from "../../../../services/logger.service";

interface UseCurrentUserReturn {
  currentUser: CurrentUser | null;
  initials: string;
  isLoaded: boolean;
  refresh: () => void;
}

function getInitials(fullname: string): string {
  if (!fullname) return "";
  const parts = fullname.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function useCurrentUser(): UseCurrentUserReturn {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const fetchUser = useCallback(async () => {
    setIsLoaded(false);
    try {
      const data = await getCurrentUser();
      setCurrentUser(data);
    } catch (error) {
      logger.error("Failed to get current user", error);
    } finally {
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return {
    currentUser,
    initials: getInitials(currentUser?.fullname || ""),
    isLoaded,
    refresh: fetchUser,
  };
}
